<template>
  <div>
    <vs-tabs v-model="currentTabIndex">
      <vs-tab v-for="(tab, tabIndex) in tabList" :key="`field_tab_${tab}`" :label="tab" @click="moveFieldTab(tabIndex, tab)" />
    </vs-tabs>

    <search-nav class="p-0" @handleSearch="onClickSearch">
      <search-year
        label="연도"
        v-model="nav.year"
        :options="{
          default: new Date().getFullYear(),
        }"
      />
      <search-keyword label="팀명" v-model="nav.teamName" />
    </search-nav>

    <div class="flex items-center justify-between mb-4 gap-4">
      <div class="summary-line">
        <template v-if="currentTabIndex === 0">
          <span class="summary-item"><b>총 등록건수:</b> {{ totalCount }}건</span>
          <span v-for="fieldName in fieldList" :key="`sum_${fieldName}`" class="summary-item">
            <b>{{ fieldName }}:</b> {{ fieldCounts[fieldName] || 0 }}건
          </span>
          <span class="summary-item"><b>개선전:</b> {{ beforeCount }}건</span>
          <span class="summary-item"><b>개선완료:</b> {{ improvedCount }}건</span>
          <span class="summary-item"><b>진행률:</b> {{ progressRate }}%</span>
        </template>
        <template v-else>
          <span class="summary-item"
            ><b>{{ currentField }} 등록건수:</b> {{ totalCount }}건</span
          >
          <span class="summary-item"><b>개선전:</b> {{ beforeCount }}건</span>
          <span class="summary-item"><b>개선완료:</b> {{ improvedCount }}건</span>
          <span class="summary-item"><b>진행률:</b> {{ progressRate }}%</span>
        </template>
      </div>
      <vs-button color="secondary" type="border" @click="onClickExcelDownload">Excel 다운로드</vs-button>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full" style="min-width: 1598px; margin-right: 2px">
        <colgroup>
          <col width="63px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="96px" />
          <col width="96px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
          <col width="122px" />
        </colgroup>
        <thead>
          <tr>
            <th colspan="15" class="text-left">
              <span>에너지검토서 완료된 사항 중 중요에너지에 해당되는 ‘M’ 등급 이상 :</span>
              <span>{{ list.length }}건</span>
            </th>
          </tr>
          <tr>
            <th rowspan="2" class="table-cell">No.</th>
            <th rowspan="2" class="table-cell">개선상태</th>
            <th rowspan="2" class="table-cell">사업장명</th>
            <th rowspan="2" class="table-cell">팀명</th>
            <th rowspan="2" class="table-cell">공장명</th>
            <th rowspan="2" class="table-cell">공정명</th>
            <th rowspan="2" class="table-cell">활동명</th>
            <th rowspan="2" class="table-cell">설비명</th>
            <th rowspan="2" class="table-cell">사용에너지</th>
            <th colspan="2" class="table-cell">등급</th>
            <th rowspan="2" class="table-cell">담당자</th>
            <th rowspan="2" class="table-cell">개선방안</th>
            <th rowspan="2" class="table-cell">개선결과</th>
            <th rowspan="2" class="table-cell">비고</th>
          </tr>
          <tr>
            <th>개선 전</th>
            <th>개선 후</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="list.length === 0">
            <td colspan="14" class="text-center py-8 text-gray-500">
              <feather-icon icon="InboxIcon" class="inline-block mb-2" style="width: 40px; height: 40px" />
              <div>데이터가 없습니다.</div>
            </td>
          </tr>
          <template v-else>
            <tr v-for="(row, rowIndex) in list" :key="`row_${row.post_id}_${row.dataCode}`">
              <!-- No. -->
              <td>{{ rowIndex + 1 }}</td>
              <!-- 상태-->
              <td>
                <span v-if="row.개선상태 === '개선완료'" class="text-success">개선 완료</span>
                <span v-else class="text-danger">개선 전</span>
              </td>
              <!-- 사업장명 -->
              <td>{{ row.사업장명 }}</td>
              <!-- 팀명 -->
              <td>{{ row.팀명 }}</td>
              <!-- 공장명 -->
              <td>{{ row.공장명 }}</td>
              <!-- 공정명 -->
              <td>{{ row.공정명 }}</td>
              <!-- 활동명 -->
              <td>{{ row.활동명 }}</td>
              <!-- 설비명 -->
              <td>{{ row.설비명 }}</td>
              <!-- 사용에너지 -->
              <td>{{ row.사용에너지 }}</td>
              <!-- 등급 / 개선 전 -->
              <td>
                <h5 class="mb-2" :style="{ color: row.등급_개선전.color }">{{ row.등급_개선전.name }}</h5>
                <vs-button class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickDetailPost(row, 'first')">원문보기</vs-button>
              </td>
              <!-- 등급 / 개선 후 -->
              <td>
                <h5 class="mb-2" :style="{ color: row.등급_개선후 ? row.등급_개선후.color : undefined }">{{ row.등급_개선후 ? row.등급_개선후.name : "-" }}</h5>
                <vs-button v-if="row.등급_개선후" class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickDetailPost(row, 'last')">원문보기</vs-button>
              </td>
              <!-- 담당자 -->
              <td>{{ row.담당자 }}</td>
              <!-- 개선방안 -->
              <td>
                <div class="flex gap-2 flex-wrap justify-center">
                  <vs-button v-if="row.개선상태 !== '개선완료'" class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선방안', false)">작성/수정</vs-button>
                  <vs-button v-if="row.raw.planResult && row.raw.planResult['개선방안']" class="px-2 py-1" type="border" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선방안', true)">보기</vs-button>
                  <p v-else>미작성</p>
                </div>
              </td>
              <!-- 개선결과 -->
              <td>
                <div class="flex gap-2 flex-wrap justify-center">
                  <vs-button v-if="row.개선상태 !== '개선완료'" class="px-2 py-1" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선결과', false)">작성/수정</vs-button>
                  <vs-button v-if="row.raw.planResult && row.raw.planResult['개선결과']" class="px-2 py-1" type="border" color="#7E72F2" style="text-wrap: nowrap" @click="onClickPost(row, '개선결과', true)">보기</vs-button>
                  <p v-else>미작성</p>
                </div>
              </td>
              <!-- 비고 -->
              <td>
                <vs-button v-if="row.개선상태 === '개선완료'" class="px-2 py-1" color="#3C3C3C">종결</vs-button>
                <vs-button v-else class="px-2 py-1" color="#FF9F43" @click="onClickResend(row)">개정</vs-button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <popup-post-viewer v-model="postViewer" v-bind="propsPostViewer">
      <template #foot="{ close }">
        <div class="p-3 flex justify-between border-top">
          <div class="flex ml-auto">
            <vs-button class="mr-2" color="#DCDFE2" style="color: #3c3c3c" @click="close">취소</vs-button>
            <vs-button v-if="propsPostViewer.개선상태 === '개선완료'" color="#3C3C3C">종결</vs-button>
            <vs-button v-else color="#7E72F2" @click="onClickResend(propsPostViewer.row)">개정</vs-button>
          </div>
        </div>
      </template>
    </popup-post-viewer>

    <popup-reformation-plan v-model="reformationPlan" v-bind="propsReformationPlanResult" @save="saveReformationPlanResult" />
    <popup-reformation-result v-model="reformationResult" v-bind="propsReformationPlanResult" @save="saveReformationPlanResult" />

    <popup-excel-download title="중요환경영향 등록부" v-model="showExcelPopup" :list="excelList" />
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import PopupPostViewer from "@/popup/PopupPostViewer.vue";
import PopupReformationPlan from "@/views/boards/single-page/902/PopupReformationPlan.vue";
import PopupReformationResult from "@/views/boards/single-page/902/PopupReformationResult.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";
import SearchYear from "@/views/list/components/SearchYear.vue";

export default {
  name: "Page",
  components: {
    SearchYear,
    SearchKeyword,
    SearchNavItemKeyword,
    PopupExcelDownload,
    PopupReformationResult,
    PopupReformationPlan,
    PopupPostViewer,
    SearchNavYearMonth,
    SearchNav,
  },

  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    fieldList() {
      return this.tabList.slice(1);
    },
    currentField() {
      return this.tabList[this.currentTabIndex] || "";
    },
    totalCount() {
      return this.list.length;
    },
    fieldCounts() {
      const counts = {};
      for (const fieldName of this.fieldList) {
        counts[fieldName] = 0;
      }
      for (const row of this.list) {
        const name = row && row.사업장명;
        if (!name) continue;
        if (counts[name] === undefined) {
          counts[name] = 0;
        }
        counts[name]++;
      }
      return counts;
    },
    improvedCount() {
      return this.list.filter((r) => r && r.개선상태 === "개선완료").length;
    },
    beforeCount() {
      return this.list.filter((r) => r && r.개선상태 === "개선전").length;
    },
    progressRate() {
      if (this.totalCount === 0) return "0.0";
      const rate = (this.improvedCount / this.totalCount) * 100;
      return rate.toFixed(1);
    },
  },
  data() {
    return {
      hasYear: false,
      currentTabIndex: 0,
      tabList: ["전사", "본사", "인천공장", "당진공장", "포항공장", "중앙기술연구소"],

      nav: {
        year: "",
        fieldName: "",
        teamName: "",
      },
      list: [],
      postViewer: false,
      propsPostViewer: { title: "" },

      reformationPlan: false,
      reformationResult: false,
      propsReformationPlanResult: { dataCode: "", postId: 0, data: undefined, readonly: false },

      showExcelPopup: false,
      excelList: [],
    };
  },

  created() {
    if (this.nav.year) {
      this.hasYear = true;
      this.loadList();
    }
  },
  mounted() {
    if (this.nav.year) {
      this.hasYear = true;
      this.loadList();
    }
  },

  methods: {
    moveFieldTab(index, tab) {
      this.loadList();
    },

    onClickSearch() {
      this.loadList();
    },

    async loadList() {
      if (!this.hasYear) return;

      const perPage = 50;

      let list = [];
      this.loading(true);
      try {
        // 원본 문서: 연도 조건 적용
        const originals = await this.loadList901(perPage);

        // M등급 항목 추출 및 원본 post_id 수집 (원본 문서에서만)
        const originMData = [];
        const originalPostIds = [];
        for (const item of originals) {
          const postId = item.post_id;
          const parentId = item.post_parent_id;
          const body = this.getItemBody(item);
          const 에너지평가목록 = body.에너지평가 || [];

          if (!parentId) {
            let hasMGrade = false;
            for (const 에너지평가 of 에너지평가목록) {
              if (this.isImportantEnergyItem(에너지평가)) {
                hasMGrade = true;
                originMData.push(`${postId}_${에너지평가.id}_${에너지평가.설비명}`);
              }
            }
            if (hasMGrade) originalPostIds.push(postId);
          }
        }

        // 개정 문서: 연도 조건 없이 원본의 모든 개정본 로드
        list.push(...originals);
        if (originalPostIds.length > 0) {
          const currentPostIds = new Set(list.map((item) => item.post_id));
          const revisions = await this.loadRevisions901(perPage, originalPostIds);
          for (const r of revisions) {
            if (!currentPostIds.has(r.post_id)) list.push(r);
          }
        }

        // 부모(또는 본인) 문서에 포함된 중요 항목이 있는 문서만 유지
        list = list.filter((item) => {
          const postId = item.post_id;
          const parentId = item.post_parent_id;
          const keyPrefix = String(parentId || postId);
          if (originMData.length > 0) {
            for (const data of originMData) {
              if (data.indexOf(keyPrefix) > -1) {
                return true;
              }
            }
          }
          return false;
        });

        // parentId (없을 경우 post_id) 를 기준으로 데이터 그룹화
        // group 의 key 에 대한 각 배열은 [0] 이 가장 오래된 데이터 [length - 1] 이 가장 최신 데이터
        const group = list.reduce((acc, cur) => {
          const parentId = cur.post_parent_id || cur.post_id;
          const body = this.getItemBody(cur);
          const 에너지평가목록 = body.에너지평가 || [];
          if (에너지평가목록.length > 0) {
            for (const 에너지평가 of 에너지평가목록) {
              const key = `${parentId}_${에너지평가.id}_${에너지평가.설비명}`;
              if (originMData.indexOf(key) > -1) {
                if (!acc[key]) acc[key] = [];
                acc[key].push(cur);
              }
            }
          }
          return acc;
        }, {});

        // 개선방안, 개선결과 리스트 불러오기
        const planResults = await this.loadPlanResultList(originMData);

        // 그룹화된 데이터를 통해 Table 에 표기 할 수 있도록 리스트 생성
        list = originMData
          .map((key) => {
            const items = group[key];
            if (!items || items.length === 0) return null;
            const first = items.find((item) => !item.post_parent_id) || items[0];
            const firstContent = { body: this.getItemBody(first) };
            const findFirstPlanResult = this.findPlanResult(key, firstContent);
            const last = this.getLastRevision(items);
            const lastContent = { body: this.getItemBody(last) };
            const findLastPlanResult = this.findPlanResult(key, lastContent);
            const temp = items.filter((item) => {
              return item.document_status && item.document_status.id === 1;
            });
            const post = {
              raw: { first, last, temp: temp.length > 0 ? temp[0] : null, planResult: planResults[key] },
              post_id: first.post_id,
              dataCode: key,
              개선상태: this.isImportantEnergyItem(findLastPlanResult) ? "개선전" : "개선완료",
              사업장명: firstContent.body.stdInfo && firstContent.body.stdInfo.field_name,
              팀명: firstContent.body.에너지검토분류 && firstContent.body.에너지검토분류.팀명,
              공장명: firstContent.body.에너지검토분류 && firstContent.body.에너지검토분류.공장명,
              공정명: firstContent.body.에너지검토분류 && firstContent.body.에너지검토분류.공정명,
              활동명: firstContent.body.에너지검토분류 && firstContent.body.에너지검토분류.활동명,
              설비명: firstContent.body.에너지검토분류 && findFirstPlanResult.설비명,
              사용에너지: firstContent.body.에너지검토분류 && findFirstPlanResult.사용에너지,
              등급_개선전: this.getRating(findFirstPlanResult && findFirstPlanResult.평가품목_평가점수, findFirstPlanResult && findFirstPlanResult.평가품목_사용량_점수),
              등급_개선후: first.post_id !== last.post_id ? this.getRating(findLastPlanResult && findLastPlanResult.평가품목_평가점수, findLastPlanResult && findLastPlanResult.평가품목_사용량_점수) : "",
              담당자: (firstContent.body.평가정보 && firstContent.body.평가정보.담당자) || firstContent.body.stdInfo.writer_name,
            };
            return post;
          })
          .filter(Boolean);

        this.list = list;
      } catch (e) {
        console.error("[902] loadList 실패:", e);
        this.list = [];
        this.notifyLoadError();
      } finally {
        this.loading(false);
      }
    },

    notifyLoadError() {
      // vs-notify 가능 시 토스트, 아니면 alert 폴백
      if (this.$vs && this.$vs.notify) {
        this.$vs.notify({
          title: "조회 오류",
          text: "서버 응답이 없어 데이터를 불러오지 못했습니다.\n잠시 후 다시 시도해 주세요.",
          color: "danger",
          time: 6000,
          position: "top-right",
        });
      } else {
        alert("서버 응답이 없어 데이터를 불러오지 못했습니다.\n잠시 후 다시 시도해 주세요.");
      }
    },

    // 901/Write.vue와 동일: 평가점수 18 이상 또는 사용량 점수 3이면 중요에너지(M)
    isImportantEnergyItem(에너지평가) {
      if (!에너지평가) return false;
      return Number(에너지평가.평가품목_평가점수) >= 18 || Number(에너지평가.평가품목_사용량_점수) === 3;
    },

    getRating(point, usageScore = 0) {
      const p = Number(point);
      const u = Number(usageScore);
      if (p >= 18 || u === 3) return { name: "M", color: "#EA5455" };
      return { name: "-", color: "#3c3c3c" };
    },

    getLastRevision(items) {
      if (items.length === 0) return undefined;
      const nonDrafts = items.filter((item) => item.document_status && item.document_status.id !== 1);
      const pool = nonDrafts.length > 0 ? nonDrafts : items;
      return pool.reduce((latest, item) => (item.post_id > latest.post_id ? item : latest));
    },

    // onlyMeta 응답(postContents.body) 또는 전체 post_content 파싱 본문 반환
    getItemBody(item) {
      if (item.postContents && item.postContents.body) return item.postContents.body;
      try {
        const parsed = JSON.parse(item.post_content || "{}");
        return parsed.body || {};
      } catch {
        return {};
      }
    },

    async loadList901(perPage) {
      const search = this.nav;
      const projectId = this.projectId;
      const page = 1;
      const boardId = 901;
      const statusIds = [1, 4]; // 1: 임시저장, 4: 승인
      const conditions = [];

      // 검색연도
      if (search.year) {
        conditions.push({ key: "created_at", operator: ">=", value: `${search.year}-01-01` });
        conditions.push({ key: "created_at", operator: "<", value: `${Number(search.year) + 1}-01-01` });
      }

      // 사업장명
      if (this.currentTabIndex > 0) {
        conditions.push({ key: "body.stdInfo.field_name", operator: "LIKE", value: `%${this.tabList[this.currentTabIndex]}%` });
      }

      // 팀명
      if (search.teamName) {
        conditions.push({ key: "body.에너지검토분류.팀명", operator: "LIKE", value: `%${search.teamName}%` });
      }

      const metaKeys = [
        "created_at",
        "body.stdInfo.field_name",
        "body.stdInfo.writer_name",
        "body.공정분류.팀명",
        "body.에너지검토분류.%",
        "body.평가정보.%",
        "body.에너지평가[%].id",
        "body.에너지평가[%].설비명",
        "body.에너지평가[%].사용에너지",
        "body.에너지평가[%].평가품목_평가점수",
        "body.에너지평가[%].평가품목_사용량_점수",
      ];

      const options = {
        projectId,
        boardSlug: `board-${boardId}`,
        isLeaf: true,
        page,
        perPage,
        conditions,
        withMeta: true,
        withoutRelation: true,
        onlyMeta: true,
        metaKeys,
        statusIds,
      };
      return await this._loadDefragmentation(options);
    },

    async loadRevisions901(perPage, parentIds) {
      const projectId = this.projectId;
      const boardId = 901;
      const statusIds = [1, 4];

      const conditions = [{ key: "post_parent_id", operator: "IN", value: parentIds }];

      const metaKeys = [
        "created_at",
        "body.stdInfo.field_name",
        "body.stdInfo.writer_name",
        "body.공정분류.팀명",
        "body.에너지검토분류.%",
        "body.평가정보.%",
        "body.에너지평가[%].id",
        "body.에너지평가[%].설비명",
        "body.에너지평가[%].사용에너지",
        "body.에너지평가[%].평가품목_평가점수",
        "body.에너지평가[%].평가품목_사용량_점수",
      ];

      const options = {
        projectId,
        boardSlug: `board-${boardId}`,
        isLeaf: true,
        page: 1,
        perPage,
        conditions,
        withMeta: true,
        withoutRelation: true,
        onlyMeta: true,
        metaKeys,
        statusIds,
      };

      return await this._loadDefragmentation(options);
    },

    // 개선방안, 개선결과 리스트
    async loadPlanResultList(groupKey) {
      const search = this.nav;
      const projectId = this.projectId;
      const boardId = 902;
      const page = 1;
      const perPage = 100;
      const conditions = [];
      if (groupKey && groupKey.length > 0) {
        conditions.push({ key: "body.dataCode", operator: "IN", value: [...groupKey] });
      }
      // 검색연도
      if (search.year) {
        conditions.push({ key: "created_at", operator: ">=", value: `${search.year}-01-01` });
        conditions.push({ key: "created_at", operator: "<", value: `${Number(search.year) + 1}-01-01` });
      }

      const options = {
        projectId,
        boardId,
        page,
        perPage,
        conditions,
      };
      const data = {};
      const list = await this._loadDefragmentation(options, "board/LOAD_POST_LIST");
      for (const post of list) {
        const body = JSON.parse(post.post_content).body;
        data[body.dataCode] = {
          id: post.id,
          ...body,
        };
      }
      return data;
    },

    // options.page 에 설정된 페이지부터 마지막 페이지까지 데이터를 불러옴
    async _loadDefragmentation(options, dispatch = "approval/LOAD_POST_ALL") {
      const response = await this._dispatchWithRetry(dispatch, options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(...(await this._loadDefragmentation(options, dispatch)));
      }
      return list;
    },

    // API 호출 실패(서버 오류/CORS 등) 시 지수 백오프로 최대 3회 재시도
    async _dispatchWithRetry(action, payload, maxAttempts = 3) {
      let lastError = null;
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
          return await this.$store.dispatch(action, payload);
        } catch (e) {
          lastError = e;
          console.warn(`[902] ${action} 실패 (시도 ${attempt}/${maxAttempts})`, e);
          if (attempt < maxAttempts) {
            const delay = 500 * Math.pow(2, attempt - 1); // 500ms, 1s, 2s
            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        }
      }
      throw lastError;
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    findPlanResult(key, content) {
      const temp = key.split("_");
      if (temp.length < 3) return undefined;
      // const postId = temp[0];
      const rowIndex = temp[1];
      // [0] [1]을 제외한 나머지 데이터 (설비명에 _ 가 포함되어 있을 경우를 대비한 것)
      const 설비명 = temp.slice(2).join("_");
      // rowIndex 는 데이터 추가/삭제 로 인해 변경될 수 있음, 따라서 설비명을 기준으로 찾음
      if (content.body.에너지평가 && content.body.에너지평가.length > 0) {
        for (let i = 0; i < content.body.에너지평가.length; i++) {
          if (content.body.에너지평가[i].설비명 === 설비명 && Number(content.body.에너지평가[i].id) === Number(rowIndex)) {
            return content.body.에너지평가[i];
          }
        }
      }
      return undefined;
    },

    async onClickResend(row) {
      const raw = row.raw.last;
      const projectId = raw.project_id;
      const boardId = raw.board_id;
      let content = null;

      if (raw.post_content && typeof raw.post_content === "string" && raw.post_content.length > 0) {
        try {
          content = JSON.parse(raw.post_content);
        } catch (e) {
          content = null;
        }
      }

      if (!content && raw.post_id) {
        this.loading(true);
        try {
          const response = await this.$store.dispatch("approval/LOAD_POST", {
            boardSlug: `board-${boardId}`,
            postId: raw.post_id,
          });
          if (response.post && response.post.post_content) {
            content = JSON.parse(response.post.post_content);
          }
        } catch (e) {
          alert("문서를 불러오는 중 오류가 발생했습니다.");
          return;
        } finally {
          this.loading(false);
        }
      }

      if (!content || !content.body) {
        alert("문서 내용을 불러올 수 없습니다.");
        return;
      }

      const parentId = raw.post_parent_id || raw.post_id;
      let postId = row.raw.temp ? row.raw.temp.post_id : 0;

      if (!postId) {
        if (confirm("개정 할 경우\n기존 문서는 유지되고, 내용이 복사되어 임시저장 됩니다.\n개정 하시겠습니까?")) {
          postId = await this.resend(projectId, boardId, parentId, content);
        }
      }

      if (postId) {
        this.$router.push(`/project/${projectId}/tab/${boardId}/write/${postId}?_t_back=902/page`);
      }
    },

    // 개정
    async resend(projectId, boardId, parentId, form) {
      const boardSlug = `board-${boardId}`;
      const title = "환경영향평가서";
      const approvalLine = []; // 개정시 결재라인 초기화

      form.body.평가정보.평가일 = new Date().format("yyyy-MM-dd");

      let postId = 0;
      await this.$store
        .dispatch("approval/CREATE_POST", {
          isTemp: 1,
          boardSlug,
          projectId,
          title,
          parentId,
          content: JSON.stringify(form),
          approvalLine: JSON.stringify(approvalLine),
          security: "normal",
          priority: "medium",
        })
        .then((response) => {
          postId = response.postId;
        });

      return postId;
    },

    async onClickPost(row, type, readonly) {
      this.propsReformationPlanResult.postId = row.raw.planResult ? row.raw.planResult.id : 0;
      this.propsReformationPlanResult.dataCode = row.dataCode;
      this.propsReformationPlanResult.readonly = readonly;
      this.propsReformationPlanResult.data = row.raw.planResult;

      if (type === "개선방안") {
        this.reformationPlan = true;
      } else if (type === "개선결과") {
        this.reformationResult = true;
      }
    },

    async onClickDetailPost(row, revision) {
      const raw = row.raw[revision];
      const boardId = raw.board_id;
      const postId = raw.post_id;
      let content = null;

      if (raw.post_content && typeof raw.post_content === "string" && raw.post_content.length > 0) {
        try {
          content = JSON.parse(raw.post_content);
        } catch (e) {
          content = null;
        }
      }

      if (!content && raw.post_id) {
        this.loading(true);
        try {
          const response = await this.$store.dispatch("approval/LOAD_POST", {
            boardSlug: `board-${boardId}`,
            postId: raw.post_id,
          });
          if (response.post && response.post.post_content) {
            content = JSON.parse(response.post.post_content);
          }
        } catch (e) {
          alert("문서를 불러오는 중 오류가 발생했습니다.");
          return;
        } finally {
          this.loading(false);
        }
      }

      if (!content || !content.body) {
        alert("문서 내용을 불러올 수 없습니다.");
        return;
      }

      this.propsPostViewer.postId = postId;
      this.propsPostViewer.boardId = boardId;
      this.propsPostViewer.body = content.body;
      this.propsPostViewer.row = row;
      this.propsPostViewer.개선상태 = row.개선상태;
      if (boardId === 901) this.propsPostViewer.title = "에너지검토서";
      this.$nextTick(() => {
        this.postViewer = true;
      });
    },

    onClickExcelDownload() {
      this.excelList = this.list.map((value, index) => {
        return {
          "No.": index + 1,
          개선상태: value.개선상태,
          사업장명: value.사업장명,
          팀명: value.팀명,
          공장명: value.공장명,
          공정명: value.공정명,
          활동명: value.활동명,
          설비명: value.설비명,
          사용에너지: value.사용에너지,
          등급_개선전: value.등급_개선전.name,
          등급_개선후: value.등급_개선후 ? value.등급_개선후.name : "-",
          담당자: value.담당자,
        };
      });

      this.showExcelPopup = true;
    },

    async saveReformationPlanResult(postId, form) {
      const projectId = this.projectId;
      const boardId = 902;
      const title = "중요환경영향 등록부 / 개선방안 및 결과";
      const content = JSON.stringify({
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          date: new Date().format("yyyy-MM-dd"),
          half: new Date().getMonth() + 1 <= 6 ? "상반기" : "하반기", //반기
        },
        body: form,
      });

      if (postId && postId > 0) {
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      } else {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      }

      await this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 0.5rem;
    text-align: center;
  }
  th {
    background-color: #f9f9f9;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    font-weight: bold;
    color: #3c3c3c;
  }
  td {
    background-color: #fff;
  }
}

.text-danger,
.text-success {
  font-size: 1rem;
  font-weight: bold;
}

.summary-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #3c3c3c;
}
.summary-line .summary-item {
  white-space: nowrap;
}
.summary-line .summary-item b {
  margin-right: 4px;
}
</style>
